// material-ui
import {
    Avatar,
    Box,
    Button,
    Card,
    CardContent,
    Chip,
    Container,
    Fade,
    Grid,
    LinearProgress,
    Paper,
    Typography,
    Zoom,
    useMediaQuery,
    useTheme
} from '@mui/material';

// import Logo from 'ui-component/Logo';
import BackgroundSlider from 'react-background-slider';

// assets
import { AccessTime, Assignment, Email, ExitToApp, Groups, LocationOn, Person, Schedule } from '@mui/icons-material';
import { images } from 'assets/images';
import { useAuth } from 'context/AuthContext';
import dayjs from 'dayjs';
import { useState } from 'react';
import AuthWrapper1 from './authentication/AuthWrapper1';

const Welcome = () => {
    const { user, logout } = useAuth();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [isSubmitting, setSubmitting] = useState(false);

    const handleLogout = async (e) => {
        setSubmitting(true);
        e.preventDefault();
        await logout();
        setSubmitting(false);
    };
    const handleContactSupport = () => {
        window.open('mailto:support@microprojects.sz.com', '_blank');
    };

    return (
        <div>
            <AuthWrapper1>
                <Box
                    sx={{
                        minHeight: '100vh',
                        background: 'linear-gradient(135deg, #1e3c72dd 0 %,#2a5298dd 100 %)',
                        display: 'flex',
                        alignItems: 'center',
                        py: 4
                    }}
                >
                    <Container maxWidth="lg">
                        <Grid container spacing={4} justifyContent="center">
                            {/* Header Section */}
                            <Grid item xs={12}>
                                <Fade in timeout={800}>
                                    <Box textAlign="center" mb={4} borderRadius={4} sx={{ background: '#1e3c72' }} mt={2} py={2}>
                                        <Avatar
                                            sx={{
                                                width: isMobile ? 80 : 120,
                                                height: isMobile ? 80 : 120,
                                                mx: 'auto',
                                                mb: 3,
                                                bgcolor: '#FFD700',
                                                border: '4px solid white',
                                                boxShadow: '0 8px 32px rgba(0,0,0,0.3)'
                                            }}
                                        >
                                            <Typography variant="h2" sx={{ color: '#1e3c72', fontWeight: 'bold' }}>
                                                MP
                                            </Typography>
                                        </Avatar>

                                        <Typography
                                            variant={isMobile ? 'h4' : 'h2'}
                                            sx={{
                                                color: 'white',
                                                fontWeight: 'bold',
                                                mb: 1,
                                                textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
                                            }}
                                        >
                                            Hi, {user?.fname} {user?.lname}!
                                        </Typography>

                                        <Typography
                                            variant={isMobile ? 'h6' : 'h4'}
                                            sx={{
                                                color: 'rgba(255,255,255,0.9)',
                                                mb: 2,
                                                fontWeight: 300
                                            }}
                                        >
                                            Welcome to Micro Projects eSwatini
                                        </Typography>

                                        <Typography
                                            variant="h6"
                                            sx={{
                                                color: '#FFD700',
                                                fontStyle: 'italic',
                                                fontWeight: 400,
                                                textShadow: '1px 1px 2px rgba(0,0,0,0.5)'
                                            }}
                                        >
                                            {`"We Empower Rural Communities To Develop Themselves"`}
                                        </Typography>
                                    </Box>
                                </Fade>
                            </Grid>

                            {/* Main Content */}
                            <Grid item xs={12} md={8}>
                                <Zoom in timeout={1000}>
                                    <Paper
                                        elevation={24}
                                        sx={{
                                            p: 4,
                                            borderRadius: 4,
                                            background: 'rgba(255,255,255,0.95)',
                                            backdropFilter: 'blur(10px)'
                                        }}
                                    >
                                        {/* Status Card */}
                                        <Card
                                            sx={{
                                                mb: 4,
                                                background: 'linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)',
                                                border: 'none'
                                            }}
                                        >
                                            <CardContent sx={{ textAlign: 'center', py: 3 }}>
                                                <Schedule sx={{ fontSize: 48, color: '#1e3c72', mb: 2 }} />
                                                <Typography variant="h5" sx={{ color: '#1e3c72', fontWeight: 'bold', mb: 1 }}>
                                                    Role Assignment Pending
                                                </Typography>
                                                <Typography variant="body1" sx={{ color: '#666', mb: 2 }}>
                                                    Your account is being reviewed by our administrators. You&apos;ll receive an email
                                                    notification once your role has been assigned.
                                                </Typography>
                                                <Chip
                                                    label="In Review"
                                                    sx={{
                                                        bgcolor: '#1e3c72',
                                                        color: 'white',
                                                        fontWeight: 'bold',
                                                        px: 2
                                                    }}
                                                />
                                            </CardContent>
                                        </Card>

                                        {/* Progress Indicator */}
                                        <Box sx={{ mb: 4 }}>
                                            <Typography variant="h6" sx={{ color: '#1e3c72', fontWeight: 'bold', mb: 2 }}>
                                                Account Setup Progress
                                            </Typography>
                                            <LinearProgress
                                                variant="determinate"
                                                value={75}
                                                sx={{
                                                    height: 8,
                                                    borderRadius: 4,
                                                    bgcolor: 'rgba(30, 60, 114, 0.1)',
                                                    '& .MuiLinearProgress-bar': {
                                                        bgcolor: '#1e3c72',
                                                        borderRadius: 4
                                                    }
                                                }}
                                            />
                                            <Typography variant="body2" sx={{ color: '#666', mt: 1 }}>
                                                75% Complete - Waiting for role assignment
                                            </Typography>
                                        </Box>

                                        {/* User Information */}
                                        <Grid container spacing={3} sx={{ mb: 4 }}>
                                            <Grid item xs={12} sm={6}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                                    <Person sx={{ color: '#1e3c72', mr: 2 }} />
                                                    <Box>
                                                        <Typography variant="body2" color="textSecondary">
                                                            Full Name
                                                        </Typography>
                                                        <Typography variant="body1" fontWeight="bold">
                                                            {user?.fname} {user?.lname}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} sm={6}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                                    <Email sx={{ color: '#1e3c72', mr: 2 }} />
                                                    <Box>
                                                        <Typography variant="body2" color="textSecondary">
                                                            Email
                                                        </Typography>
                                                        <Typography variant="body1" fontWeight="bold">
                                                            {user?.email}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} sm={6}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                                    <LocationOn sx={{ color: '#1e3c72', mr: 2 }} />
                                                    <Box>
                                                        <Typography variant="body2" color="textSecondary">
                                                            Location
                                                        </Typography>
                                                        <Typography variant="body1" fontWeight="bold">
                                                            {user?.location}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} sm={6}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                                    <AccessTime sx={{ color: '#1e3c72', mr: 2 }} />
                                                    <Box>
                                                        <Typography variant="body2" color="textSecondary">
                                                            Member Since
                                                        </Typography>
                                                        <Typography variant="body1" fontWeight="bold">
                                                            {dayjs(user?.createdAt).locale('en').format('YYYY-MM-DD HH:mm:ss')}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Grid>
                                        </Grid>

                                        {/* Next Steps */}
                                        <Card sx={{ mb: 4, bgcolor: '#f8f9fa' }}>
                                            <CardContent>
                                                <Typography variant="h6" sx={{ color: '#1e3c72', fontWeight: 'bold', mb: 2 }}>
                                                    What happens next?
                                                </Typography>
                                                <Box component="ol" sx={{ pl: 2 }}>
                                                    <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                                                        Our administrators will review your application
                                                    </Typography>
                                                    <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                                                        You&apos;ll receive an email notification with your assigned role
                                                    </Typography>
                                                    <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                                                        Access will be granted to relevant system modules
                                                    </Typography>
                                                    <Typography component="li" variant="body1">
                                                        You can start participating in micro projects!
                                                    </Typography>
                                                </Box>
                                            </CardContent>
                                        </Card>

                                        {/* Action Buttons */}
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={6}>
                                                <Button
                                                    fullWidth
                                                    variant="contained"
                                                    onClick={handleContactSupport}
                                                    sx={{
                                                        bgcolor: '#1e3c72',
                                                        color: 'white',
                                                        py: 1.5,
                                                        borderRadius: 2,
                                                        fontWeight: 'bold',
                                                        '&:hover': {
                                                            bgcolor: '#2a5298',
                                                            transform: 'translateY(-2px)',
                                                            boxShadow: '0 8px 25px rgba(30, 60, 114, 0.3)'
                                                        },
                                                        transition: 'all 0.3s ease'
                                                    }}
                                                >
                                                    <Email sx={{ mr: 1 }} />
                                                    Contact Support
                                                </Button>
                                            </Grid>

                                            <Grid item xs={12} sm={6}>
                                                <Button
                                                    fullWidth
                                                    variant="outlined"
                                                    onClick={handleLogout}
                                                    disabled={isSubmitting}
                                                    sx={{
                                                        borderColor: '#1e3c72',
                                                        color: '#1e3c72',
                                                        py: 1.5,
                                                        borderRadius: 2,
                                                        fontWeight: 'bold',
                                                        '&:hover': {
                                                            borderColor: '#2a5298',
                                                            bgcolor: 'rgba(30, 60, 114, 0.04)',
                                                            transform: 'translateY(-2px)'
                                                        },
                                                        transition: 'all 0.3s ease'
                                                    }}
                                                >
                                                    {isSubmitting ? (
                                                        <LinearProgress sx={{ width: 100, height: 4 }} />
                                                    ) : (
                                                        <>
                                                            <ExitToApp sx={{ mr: 1 }} />
                                                            Sign Out
                                                        </>
                                                    )}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Zoom>
                            </Grid>

                            {/* Side Information */}
                            <Grid item xs={12} md={4}>
                                <Fade in timeout={1200}>
                                    <Paper
                                        elevation={12}
                                        sx={{
                                            p: 3,
                                            borderRadius: 4,
                                            background: 'rgba(255,255,255,0.95)',
                                            backdropFilter: 'blur(10px)',
                                            height: 'fit-content'
                                        }}
                                    >
                                        <Typography variant="h6" sx={{ color: '#1e3c72', fontWeight: 'bold', mb: 3 }}>
                                            About Micro Projects eSwatini
                                        </Typography>

                                        <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 3 }}>
                                            <Groups sx={{ color: '#1e3c72', mr: 2, mt: 0.5 }} />
                                            <Box>
                                                <Typography variant="subtitle2" fontWeight="bold" color="#1e3c72">
                                                    Community Focused
                                                </Typography>
                                                <Typography variant="body2" color="textSecondary">
                                                    Supporting rural development through community-driven initiatives
                                                </Typography>
                                            </Box>
                                        </Box>

                                        <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 3 }}>
                                            <Assignment sx={{ color: '#1e3c72', mr: 2, mt: 0.5 }} />
                                            <Box>
                                                <Typography variant="subtitle2" fontWeight="bold" color="#1e3c72">
                                                    Project Management
                                                </Typography>
                                                <Typography variant="body2" color="textSecondary">
                                                    Streamlined tools for effective project planning and execution
                                                </Typography>
                                            </Box>
                                        </Box>

                                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                            <LocationOn sx={{ color: '#1e3c72', mr: 2, mt: 0.5 }} />
                                            <Box>
                                                <Typography variant="subtitle2" fontWeight="bold" color="#1e3c72">
                                                    Kingdom of eSwatini
                                                </Typography>
                                                <Typography variant="body2" color="textSecondary">
                                                    Empowering communities across all regions of eSwatini
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Paper>
                                </Fade>
                            </Grid>
                        </Grid>
                    </Container>
                </Box>
            </AuthWrapper1>
            <BackgroundSlider images={images} duration={5} transition={2} />
        </div>
    );
};

export default Welcome;
